import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  ClickAwayListener,
  Divider,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Modal,
  Paper,
  Popper,
  Skeleton,
  Stack,
  SvgIcon,
  Table,
  TableCell,
  TableRow,
  Typography,
  useMediaQuery
} from '@mui/material';
import { Box } from '@mui/system';
import PlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import UploadIcon from '@untitled-ui/icons-react/build/esm/Upload01';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DropzoneArea } from 'react-mui-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import DeletePopupModal from 'src/components/common-modals/delete-modal';
import { paths } from 'src/paths';
import {
  deleteSingleMdsAssessment,
  getAssessment,
  getMdsAssessment,
  getMultipleMDAAssessment,
  getValidationCSVTemplateOfMds,
  resetDeleteSingleMdsAssessment,
} from 'src/redux/actions/therapyPlanning';
import assessmentIcon from '../../icons/untitled-ui/duocolor/assessment1.png';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import MultipleMdsAssessmentTable from './multiple-mds-assesment-table';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
const { therapyPlanning } = paths;

const CreateMDSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15 7.875V5.1C15 3.83988 15 3.20982 14.7548 2.72852C14.539 2.30516 14.1948 1.96095 13.7715 1.74524C13.2902 1.5 12.6601 1.5 11.4 1.5H6.6C5.33988 1.5 4.70982 1.5 4.22852 1.74524C3.80516 1.96095 3.46095 2.30516 3.24524 2.72852C3 3.20982 3 3.83988 3 5.1V12.9C3 14.1601 3 14.7902 3.24524 15.2715C3.46095 15.6948 3.80516 16.039 4.22852 16.2548C4.70982 16.5 5.33988 16.5 6.6 16.5H9M13.5 15.75V11.25M11.25 13.5H15.75"
        stroke="#6366F1"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const MDSAssessment = () => {
  const isTabletScreen = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const anchorRef = useRef<any>(null);
  const [popUpContent, setPopup] = useState(false);
  const [uploadCsvModal, setUploadCsvModal] = useState(false);
  const [isWarning, setIsWarning] = useState(false);
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [fileUploaded, setFileUploaded] = useState<any>();

  const handleClose = useCallback((event: Event): void => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setPopup(false);
  }, []);
  const handleAddPatientPopUp = useCallback((): void => {
    setPopup((prevOpen) => !prevOpen);
  }, []);
  const patientInfo = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);
  const dispatch = useDispatch();
  const mdsAssessmentDetails = useSelector(
    (state: any) => state?.getMDSAssessmentReducer?.response?.data
  );
  const mdsAssessmentResponse = useSelector((state: any) => state?.getMDSAssessmentReducer);
  const assessmentResponse = useSelector((state: any) => state?.getAssessmentReducer);
  const assessmentDetails = useSelector(
    (state: any) => state?.getAssessmentReducer?.response?.data
  );
  const getMultipleMdsAssessment = useSelector((state: any) => state.getMultipleMDSAssessment);

  const [multipleMdsAssessment, setMultipleMdsAssessment] = useState({
    open: [],
    closed: [],
  });

  useEffect(() => {
    if (getMultipleMdsAssessment?.response?.data?.length) {
      if (location?.state?.from === 'ARD_Tab') {
        const getOpenEoc = getMultipleMdsAssessment?.response?.data?.filter(
          (mds: any) => mds?.status === 'OPENED'
        );
        const mdsAssessment = getOpenEoc?.[0]?.mdsAssessments?.filter((mds: any) => {
          if (mds?.isFinalMds) {
            return mds?.finalMds?.assessmentDate.split("T")[0] === location?.state?.ARD_Date
          }
          return mds?.assessmentDate?.split("T")[0] === location?.state?.ARD_Date
        })
        const openEocWithMds = [
          {
            ...getOpenEoc?.[0],
            mdsAssessments: mdsAssessment
          }
        ]
        setMultipleMdsAssessment((prev: any) => ({
          ...prev,
          open: openEocWithMds,
          closed: [],
        }));
        return
      } else {
      const getOpenEoc = getMultipleMdsAssessment?.response?.data?.filter(
        (mds: any) => mds?.status === 'OPENED'
      );
      const getClosed = getMultipleMdsAssessment?.response?.data?.filter(
        (mds: any) => mds?.status === 'CLOSED'
      );
      setMultipleMdsAssessment((prev) => ({
        ...prev,
        open: getOpenEoc,
        closed: getClosed,
      }));
    }
    }
  }, [getMultipleMdsAssessment]);

  useEffect(() => {
    if (patientInfo) {
      dispatch(
        getMdsAssessment({
          patientId: patientInfo?.uuid,
        })
      );
      if (patientInfo?.isMdsPresent)
        dispatch(
          getAssessment({
            patientId: patientInfo?.uuid,
          })
        );
      dispatch(
        getMultipleMDAAssessment({
          patientId: patientInfo?.uuid,
        })
      );
    }
  }, [patientInfo]);

  const assessmentDate = assessmentDetails?.assessmentDate?.split('T')?.at(0);
  const assessmentDateWithoutTimezone =
    assessmentDetails?.assessmentDate &&
    new Date(
      new Date(assessmentDate).valueOf() + new Date(assessmentDate).getTimezoneOffset() * 60 * 1000
    );

  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleEditMultipleMds = (mds: any) => {
    navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`, {
      state: {
        action: 'Edit',
        selectedPatient: patientInfo,
        assessmentDetails: mds,
        ARD_Date: location?.state?.from === 'ARD_Tab' ? location?.state?.ARD_Date : null,
        from: location?.state?.from === 'ARD_Tab' ? 'ARD_Tab' : null,
      },
    });
  };
  const [deleteMds, setDeleteMds] = useState<any>('')
  const [deleteMdsAssessment, setDeleteMdsAssessment] = useState(false)
  const handleDeleteMds = () => {
    dispatch(deleteSingleMdsAssessment({
      mdsId: deleteMds?.uuid
    }))
    setDeleteMdsAssessment(false)
  }

  const handleDeleteMultipleMds = (mds: any) => {
    setDeleteMds(mds)
    setDeleteMdsAssessment(true)
  }
  const deleteMdsAssessmentDate = useSelector((state: any) => state.deleteSingleMdsAssessmentReducer)
  useEffect(() => {
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate?.response === null
    )
      return;
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate !== null
    ) {
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        dispatch(resetDeleteSingleMdsAssessment());
        setMessage('');
      }, 3000);
      return;
    } else {
      // getPerWeekNavigationAPI();
      dispatch(
        getMultipleMDAAssessment({
          patientId: patientInfo?.uuid,
        })
      );
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setMessage('');
        setIsSnackBarOpen(false);
        dispatch(resetDeleteSingleMdsAssessment());
      }, 3000);
    }
  }, [deleteMdsAssessmentDate]);


  function addNewMdsAssessment() {
    navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`, {
      state: {
        action: 'Create',
        selectedPatient: patientInfo,
        ARD_Date: location?.state?.from === 'ARD_Tab' ? location?.state?.ARD_Date : null,
        from: location?.state?.from === 'ARD_Tab' ? 'ARD_Tab' : null,
      },
    });
  }
  const handleUploadCsvModal = () => {
    setUploadCsvModal(true);
  };
  const handleCloseUploadCsvModal = () => {
    setUploadCsvModal(false);
  };
  const handleDownloadCSVTemplate = () => {
    // dispatch(getDownloadCSVPatientTemplate());
    // downloadFile(getDownloadCSVResponse);
  };

  const handleUploadValidationTemplate = () => {
    const formData = new FormData();
    formData.append('file', fileUploaded[0]);

    dispatch(getValidationCSVTemplateOfMds(formData));
    navigate(`/scheduling/therapy-planning/upload`);
  };

  return (
    <Stack
      sx={{
        padding: '1.5rem',
        maxHeight:
          location.pathname === '/scheduling/therapy-planning/details/info'
            ? {
                lg: '94vh',

                sm: '70vh',
              }
            : `calc(100vh - 300px)`,
        overflow: 'auto',
        marginBottom: '12px',
      }}
      flexDirection="row"
      gap="1rem"
    >
      <Stack
        width={'100%'}
        py={1.5}
      >
        {getMultipleMdsAssessment?.loading ? (
          <>
            <Stack
              flexDirection={'row'}
              justifyContent={'center'}
              alignItems={'center'}
              width={'100%'}
            >
              <Stack
                alignItems="center"
                justifyContent="center"
                width={'90%'}
                gap="1.5rem"
                sx={{ marginTop: '3rem' }}
              >
                {['1', '2', '3'].map((res) => {
                  return (
                    <Table key={res}>
                      <TableRow key={res}>
                        {['1', '2', '3'].map((sle) => {
                          return (
                            <TableCell key={sle}>
                              <Box
                                sx={{
                                  width: '100%',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                }}
                                key={sle}
                              >
                                <Typography
                                  width={'100%'}
                                  variant="h2"
                                >
                                  <Skeleton animation={false} />
                                </Typography>
                              </Box>
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </Table>
                  );
                })}
              </Stack>
            </Stack>
            <Typography
              width={'15%'}
              variant="h2"
              mt={5}
              ml={9}
            >
              <Skeleton animation={false} />
            </Typography>
          </>
        ) : (
          <>
            <>
              {(multipleMdsAssessment.open[0] as any)?.mdsAssessments.length ||
              multipleMdsAssessment.closed.length ? (
                <>
                  <Stack
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                  >
                    <Typography variant="h6">Assessments Per Episode of Care</Typography>
                    <Button
                      startIcon={<CreateMDSIcon />}
                      variant="text"
                      ref={anchorRef}
                      onClick={handleAddPatientPopUp}
                      // onClick={() =>
                      //   navigate(
                      //     `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`,
                      //     {
                      //       state: {
                      //         action: 'Create',
                      //         selectedPatient: patientInfo,
                      //       },
                      //     }
                      //   )
                      // }
                    >
                      Create new MDS assessment
                    </Button>
                    <Popper
                      anchorEl={anchorRef.current}
                      open={popUpContent}
                      transition
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === 'bottom' ? 'center top' : 'center bottom',
                            boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
                            borderRadius: '12px',
                            background: '#fff',
                            // width: 'auto',
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                              <MenuList>
                                <MenuItem onClick={addNewMdsAssessment}>
                                  <Grid container>
                                    <Grid
                                      item
                                      marginRight={1}
                                    >
                                      <SvgIcon
                                        sx={{
                                          color: '#6C737F',
                                        }}
                                      >
                                        <PlusIcon />
                                      </SvgIcon>
                                    </Grid>
                                    <Grid item>
                                      {' '}
                                      <Typography
                                        color={'#6C737F'}
                                        variant="subtitle2"
                                      >
                                        Add Assessment Details
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </MenuItem>

                                <MenuItem onClick={handleUploadCsvModal}>
                                  <Grid container>
                                    <Grid
                                      item
                                      marginRight={1}
                                    >
                                      <SvgIcon
                                        sx={{
                                          color: '#6C737F',
                                        }}
                                      >
                                        <UploadIcon />
                                      </SvgIcon>
                                    </Grid>
                                    <Grid item>
                                      {' '}
                                      <Typography
                                        color={'#6C737F'}
                                        variant="subtitle2"
                                      >
                                        Upload CSV File
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </Stack>
                </>
              ) : (
                <Stack
                  flexDirection={'row'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <Stack
                    alignItems="center"
                    justifyContent="center"
                    gap="1.5rem"
                    sx={{ marginTop: '3rem' }}
                  >
                    <img
                      src={assessmentIcon}
                      width="125px"
                      height="125px"
                      alt=""
                      style={{
                        objectFit: 'cover',
                      }}
                    />
                    <Stack>
                      <Typography
                        sx={{ textAlign: 'center' }}
                        variant="h5"
                      >
                        Not Created Yet
                      </Typography>
                      <Typography
                        sx={{ textAlign: 'center', fontSize: '14px', color: '#6C737F' }}
                        variant="body1"
                      >
                        Add details about assessment date, type, MDS PT - OT, MDS SLP, MDS Nursing
                        and MDS NTA
                      </Typography>
                    </Stack>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ width: 'max-content' }}
                      // onClick={() =>
                      //   navigate(
                      //     `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`,
                      //     {
                      //       state: {
                      //         action: 'Create',
                      //         selectedPatient: patientInfo,
                      //       },
                      //     }
                      //   )
                      // }
                      onClick={handleAddPatientPopUp}
                      ref={anchorRef}
                      endIcon={
                        <SvgIcon>
                          <ExpandMoreIcon />
                        </SvgIcon>
                      }
                      startIcon={<AddOutlinedIcon />}
                    >
                      Add Assessment Details
                    </Button>
                    <Popper
                      anchorEl={anchorRef.current}
                      open={popUpContent}
                      transition
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === 'bottom' ? 'center top' : 'center bottom',
                            boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
                            borderRadius: '12px',
                            background: '#fff',
                            // width: 'auto',
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                              <MenuList>
                                <MenuItem onClick={addNewMdsAssessment}>
                                  <Grid container>
                                    <Grid
                                      item
                                      marginRight={1}
                                    >
                                      <SvgIcon
                                        sx={{
                                          color: '#6C737F',
                                        }}
                                      >
                                        <PlusIcon />
                                      </SvgIcon>
                                    </Grid>
                                    <Grid item>
                                      {' '}
                                      <Typography
                                        color={'#6C737F'}
                                        variant="subtitle2"
                                      >
                                        Add Assessment Details
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </MenuItem>

                                <MenuItem onClick={handleUploadCsvModal}>
                                  <Grid container>
                                    <Grid
                                      item
                                      marginRight={1}
                                    >
                                      <SvgIcon
                                        sx={{
                                          color: '#6C737F',
                                        }}
                                      >
                                        <UploadIcon />
                                      </SvgIcon>
                                    </Grid>
                                    <Grid item>
                                      {' '}
                                      <Typography
                                        color={'#6C737F'}
                                        variant="subtitle2"
                                      >
                                        Upload CSV File
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </Stack>
                </Stack>
              )}
            </>

            <Modal
              open={uploadCsvModal}
              onClose={handleCloseUploadCsvModal}
              sx={{ p: 0 }}
            >
              <Card
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '55%',
                  borderRadius: '8px',
                  padding: '16px',
                  maxHeight: '90%',
                }}
              >
                <CardHeader
                  title="Upload MDS Assessment"
                  sx={{
                    padding: '16px',
                    '& .MuiTypography-root': {
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontWeight: 700,
                      fontSize: '1.5rem',
                      lineHeight: 1.2,
                    },
                  }}
                />
                <Divider />
                <CardContent sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                  <DropzoneArea
                    filesLimit={1}
                    onChange={(files: any) => setFileUploaded(files)}
                    dropzoneText={
                      <div>
                        <p>Drag & Drop or Click To Browse</p>
                        <Button>Browse</Button>
                      </div>
                    }
                    showFileNames={true}
                    Icon={(props: any) => null}
                  />
                  <Stack>
                    {/* <Button onClick={handleDownloadCSVTemplate}>
                      <Typography
                        variant="h6"
                        color="#6366F1"
                        textAlign="center"
                      >
                        Download MSD Assessment CSV Template
                      </Typography>
                    </Button> */}
                  </Stack>
                  <Stack>
                    <Typography
                      variant="h6"
                      textAlign="center"
                    >
                      Enter MSD Assessment information into the template, then re-upload the file.
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography
                      variant="h6"
                      textAlign="center"
                    >
                      Maximum upload file size: 10 MB.
                    </Typography>
                  </Stack>
                </CardContent>
                <Stack
                  flexDirection="row"
                  gap="1rem"
                  justifyContent="flex-end"
                  sx={{ marginTop: '1rem' }}
                >
                  <Button
                    color="inherit"
                    onClick={handleCloseUploadCsvModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleUploadValidationTemplate}
                    disabled={!fileUploaded?.[0]}
                  >
                    Upload
                  </Button>
                </Stack>
              </Card>
            </Modal>

            {(multipleMdsAssessment.open[0] as any)?.mdsAssessments.length ||
            multipleMdsAssessment.closed.length ? (
              <>
                <Stack my={1}>
                  <MultipleMdsAssessmentTable
                    handleEditMultipleMds={handleEditMultipleMds}
                    mdsAssessmentData={multipleMdsAssessment.open[0]}
                    expanded={expanded}
                    handleExpandClick={handleExpandClick}
                    seeButton={true && multipleMdsAssessment?.closed?.length}
                        handleDeleteMultipleMds={handleDeleteMultipleMds}
                  />
                </Stack>
                <>
                  {multipleMdsAssessment?.closed?.length ? (
                    <>
                      {expanded ? (
                        <>
                          {multipleMdsAssessment?.closed?.map((mds: any) => {
                            return (
                              <Stack py={1}>
                                <MultipleMdsAssessmentTable
                                  mdsAssessmentData={mds}
                                  handleEditMultipleMds={handleEditMultipleMds}
                                  seeButton={false}
                                  handleDeleteMultipleMds={handleDeleteMultipleMds}
                                />
                              </Stack>
                            );
                          })}
                        </>
                      ) : null}
                    </>
                  ) : null}
                </>
              </>
            ) : null}
          </>
        )}
      </Stack>
      <BootstrapDialog
        onClose={() => setDeleteMdsAssessment(false)}
        aria-labelledby="customized-dialog-title"
        open={deleteMdsAssessment}
      >
        <DeletePopupModal
          close={() => setDeleteMdsAssessment(false)}
          message={'This action cannot be undone.'}
          button={{ saveLabel: 'Delete', closeLabel: 'Cancel' }}
          title={'Delete MDS Assessment?'}
          handleSaveBtn={handleDeleteMds}
        />
      </BootstrapDialog>
      {isSnackBarOpen && (
        <SimpleSnackbar
          message={message}
          isWarning={isWarning}

        />
      )}
    </Stack>
  );
};

export default React.memo(MDSAssessment);
